<template>
    <v-row>
        <v-col cols="12" md="4">
            <v-card ref="applicationsCard" class="fill-height">
                <v-card-title>
                    Online Residence Applications
                </v-card-title>
                <v-card-subtitle>
                    <v-select v-model="residenceTerm" append-icon="mdi-restart" class="pt-3" :items="getResidenceTerms"
                        label="Residence Term" placeholder="Please select.." prepend-icon="mdi-calendar-range"
                        @change="updateData()" @click:append="resetData()">
                    </v-select>
                </v-card-subtitle>
                <v-card-text class="statistics__heading">
                    Total Applications: {{ statistics.total || 'N/A' }}
                </v-card-text>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" lg="6">
                            <v-card :color="infoColor">
                                <v-card-title class="pb-1">
                                    <v-icon large>mdi-play</v-icon>
                                    <v-spacer></v-spacer>
                                    {{ getApplicationStatus('Inprocess') }}
                                </v-card-title>
                                <v-card-text class="font-weight-bold pb-4">
                                    In-process
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-card :color="warningColor">
                                <v-card-title class="pb-1">
                                    <v-icon large>mdi-clock</v-icon>
                                    <v-spacer></v-spacer>
                                    {{ getApplicationStatus('Waiting') }}
                                </v-card-title>
                                <v-card-text class="font-weight-bold pb-4">
                                    Waiting List
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-card :color="successColor">
                                <v-card-title class="pb-1">
                                    <v-icon large>mdi-check</v-icon>
                                    <v-spacer></v-spacer>
                                    {{ getApplicationStatus('Completed') }}
                                </v-card-title>
                                <v-card-text class="font-weight-bold pb-4">
                                    Completed
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-card :color="dangerColor">
                                <v-card-title class="pb-1">
                                    <v-icon large>mdi-cancel</v-icon>
                                    <v-spacer></v-spacer>
                                    {{ getApplicationStatus('Withdrawn') }}
                                </v-card-title>
                                <v-card-text class="font-weight-bold pb-4">
                                    Withdrawn
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-card :color="secondaryColor">
                                <v-card-title class="pb-1">
                                    <v-icon large>mdi-help</v-icon>
                                    <v-spacer></v-spacer>
                                    {{ getApplicationStatus('Unspecified') }}
                                </v-card-title>
                                <v-card-text class="font-weight-bold pb-4">
                                    Not Specified
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" md="4">
            <v-card ref="genderCard" class="fill-height">
                <v-card-title>
                    Applicants By Gender(s)
                </v-card-title>
                <v-card-subtitle>
                    {{ residenceTerm || 'All Residence Terms' }}
                </v-card-subtitle>
                <v-card-text>
                    <v-row>
                        <v-col cols="7" class="my-auto statistics__heading">
                            Female ({{ getGenderCount('F') }})
                        </v-col>
                        <v-col cols="5">
                            <v-progress-circular class="font-weight-bold" :rotate="360" :size="80" :width="14"
                                :value="getGender('F')" :color="infoColor">
                                {{ getGender('F') }}%
                            </v-progress-circular>
                        </v-col>
                        <v-col cols="7" class="my-auto statistics__heading">
                            Male ({{ getGenderCount('M') }})
                        </v-col>
                        <v-col cols="5">
                            <v-progress-circular class="font-weight-bold" :rotate="360" :size="80" :width="14"
                                :value="getGender('M')" :color="infoColor">
                                {{ getGender('M') }}%
                            </v-progress-circular>
                        </v-col>
                        <v-col cols="7" class="my-auto statistics__heading">
                            Non-Binary ({{ getGenderCount('NonBinary') }})
                        </v-col>
                        <v-col cols="5">
                            <v-progress-circular class="font-weight-bold" :rotate="360" :size="80" :width="14"
                                :value="getGender('NonBinary')" :color="infoColor">
                                {{ getGender('NonBinary') }}%
                            </v-progress-circular>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" md="4">
            <v-card ref="residencyCard" class="fill-height">
                <v-card-title>
                    Applicants By Residency
                </v-card-title>
                <v-card-subtitle>
                    {{ residenceTerm || 'All Residence Terms' }}
                </v-card-subtitle>
                <v-card-text>
                    <v-row>
                        <v-col cols="5" class="my-auto statistics__heading">
                            Domestic ({{ getResidencyCount('domestic') }})
                        </v-col>
                        <v-col cols="7">
                            <v-progress-linear class="white--text" :color="successColor" height="25"
                                :value="getResidency('domestic')">
                                {{ getResidency('domestic') }}%
                            </v-progress-linear>
                        </v-col>
                        <v-col cols="5" class="my-auto statistics__heading">
                            International ({{ getResidencyCount('international') }})
                        </v-col>
                        <v-col cols="7">
                            <v-progress-linear class="white--text" :color="infoColor" height="25"
                                :value="getResidency('international')">
                                {{ getResidency('international') }}%
                            </v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'home-statistics',
    props: {
        residenceBool: {
            required: true
        },
        residenceTerms: {
            required: true
        },
        statistics: {
            required: true
        }
    },
    data() {
        return {
            residenceTerm: ''
        }
    },
    methods: {
        getApplicationStatus(status) {
            if (this.statistics.applicationStatus) {
                if (status == "Inprocess" && this.statistics.applicationStatus['In-process']) {
                    return this.statistics.applicationStatus['In-process'];
                } else if (status == "Waiting" && this.statistics.applicationStatus['Waiting list']) {
                    return this.statistics.applicationStatus['Waiting list'];
                } else if (status == "Completed" && this.statistics.applicationStatus['Completed']) {
                    return this.statistics.applicationStatus['Completed'];
                } else if (status == "Withdrawn" && this.statistics.applicationStatus['Withdrawn']) {
                    return this.statistics.applicationStatus['Withdrawn'];
                } else if (status == "Unspecified" && this.statistics.applicationStatus['unspecified']) {
                    return this.statistics.applicationStatus['unspecified'];
                }
            }

            return 0;
        },
        getGender(gender) {
            let value = 0;
            let f = this.statistics.gender && this.statistics.gender.F ? this.statistics.gender.F : 0;
            let m = this.statistics.gender && this.statistics.gender.M ? this.statistics.gender.M : 0;
            let other = this.statistics.gender && this.statistics.gender.Other ? this.statistics.gender.Other : 0;
            let nonbin = this.statistics.gender && this.statistics.gender.NonBinary ? this.statistics.gender.NonBinary : 0;
            let total = f + m + other + nonbin || 0;

            if (total == 0)
                return value;

            if (gender == "F") {
                value = Math.round(((f / total) * 100));
            } else if (gender == "M") {
                value = Math.round(((m / total) * 100));
            } else if (gender == "Other" || gender == "NonBinary") {
                value = Math.round((((other+nonbin)/ total) * 100));
            }

            return value;
        },
        getGenderCount(gender) {
            let count = 0;
            let f = this.statistics.gender && this.statistics.gender.F ? this.statistics.gender.F : 0;
            let m = this.statistics.gender && this.statistics.gender.M ? this.statistics.gender.M : 0;
            let other = this.statistics.gender && this.statistics.gender.Other ? this.statistics.gender.Other : 0;
            let nonbin = this.statistics.gender && this.statistics.gender.NonBinary ? this.statistics.gender.NonBinary : 0;
            let total = f + m + other + nonbin || 0;

            if (total == 0)
                return count;

            if (gender == "F") {
                count = `${f}/${total}`;
            } else if (gender == "M") {
                count = `${m}/${total}`;
            } else if (gender == "Other"  || gender == "NonBinary") {
                count = `${other+nonbin}/${total}`;
            }

            return count;
        },
        getResidenceTerm() {
            return this.residenceTerm;
        },
        getResidency(type) {
            let value = 0;
            let domestic = this.statistics.residency && this.statistics.residency.domestic ? this.statistics.residency.domestic : 0;
            let international = this.statistics.residency && this.statistics.residency.international ? this.statistics.residency.international : 0;
            let total = domestic + international || 0;

            if (total == 0)
                return value;

            if (type == "domestic") {
                value = Math.round(((domestic / total) * 100));
            } else if (type == "international") {
                value = Math.round(((international / total) * 100));
            }

            return value;
        },
        getResidencyCount(type) {
            let count = 0;
            let domestic = this.statistics.residency && this.statistics.residency.domestic ? this.statistics.residency.domestic : 0;
            let international = this.statistics.residency && this.statistics.residency.international ? this.statistics.residency.international : 0;
            let total = domestic + international || 0;

            if (total == 0)
                return count;

            if (type == "domestic") {
                count = `${domestic}/${total}`;
            } else if (type == "international") {
                count = `${international}/${total}`;
            }

            return count;
        },
        resetData() {
            this.residenceTerm = '';
            this.$refs.applicationsCard.loading = true;
            this.$refs.genderCard.loading = true;
            this.$refs.residencyCard.loading = true;
            this.setResidenceBool(false);
            this.$emit('refreshData');
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.applicationsCard.loading = false;
                    this.$refs.genderCard.loading = false;
                    this.$refs.residencyCard.loading = false;
                }, 1000);
            })
        },
        setResidenceBool(bool) {
            this.$emit('setResidenceBool', bool);
        },
        updateData() {
            // Loading
            this.$refs.applicationsCard.loading = true;
            this.$refs.genderCard.loading = true;
            this.$refs.residencyCard.loading = true;
            this.setResidenceBool(true);
            this.$emit('refreshData');
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.applicationsCard.loading = false;
                    this.$refs.genderCard.loading = false;
                    this.$refs.residencyCard.loading = false;
                }, 1000);
            })
        }
    },
    computed: {
        appColor() {
            return '#191b2a';
        },
        dangerColor() {
            return '#f64e60';
        },
        getResidenceTerms() {
            let residenceTermsItems = [];

            if (this.residenceTerms) {
                residenceTermsItems.push({
                    text: 'All Residence Terms',
                    value: ''
                });
                residenceTermsItems = residenceTermsItems.concat(this.residenceTerms);
            }

            return residenceTermsItems;
        },
        infoColor() {
            return '#5578eb';
        },
        primaryColor() {
            return '#5867dd';
        },
        secondaryColor() {
            return '#6d6e71';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>

<style>
.v-card__text {
    font-size: 16px;
}

.statistics__heading {
    color: #3F4254 !important;
    font-size: 16px;
    font-weight: 600;
}
</style>